<template>
  <div>
    <div class="newQuestionsBackground md:py-12">
      <div class="buttonDiv">
        <BackButton />
        <h2 class="questionTitle">Which of the following is most pressing?</h2>

        <div class="paddingButtons">
          <div data-aos="fade-left" class="checkboxes">
            <!-- Q7-1-->

            <span
              v-if="
                $store.state.views.questionSeven.checkedButtons[0] === idArry[0]
              "
            >
              <input
                type="checkbox"
                id="option1"
                v-on:click="checkboxesChecked"
                name="question7-1"
                checked
              />

              <label for="option1"> Academics</label>
            </span>

            <span v-else>
              <input
                type="checkbox"
                id="option1"
                v-on:click="checkboxesChecked"
                name="question7-1"
              />

              <label for="option1"> Academics</label>
            </span>
            <!-- Q7-2-->

            <span
              v-if="
                $store.state.views.questionSeven.checkedButtons[1] === idArry[1]
              "
            >
              <input
                type="checkbox"
                id="option2"
                v-on:click="checkboxesChecked"
                name="question7-1"
                checked
              />

              <label for="option2"> {{ answerOptions1[1] }}</label>
            </span>

            <span v-else>
              <input
                type="checkbox"
                id="option2"
                v-on:click="checkboxesChecked"
                name="question7-1"
              />
              <label for="option2"> {{ answerOptions1[1] }}</label>
            </span>

            <!-- Q7-3-->

            <span
              v-if="
                $store.state.views.questionSeven.checkedButtons[2] === idArry[2]
              "
            >
              <input
                type="checkbox"
                id="option3"
                v-on:click="checkboxesChecked"
                name="question7-1"
                checked
              />

              <label for="option3"> Finances</label>
            </span>

            <span v-else>
              <input
                type="checkbox"
                id="option3"
                v-on:click="checkboxesChecked"
                name="question7-1"
              />

              <label for="option3"> Finances</label>
            </span>

            <!-- Q7-4-->

            <span
              v-if="
                $store.state.views.questionSeven.checkedButtons[3] === idArry[3]
              "
            >
              <input
                type="checkbox"
                id="option4"
                v-on:click="checkboxesChecked"
                name="question7-1"
                checked
              />

              <label for="option4"> Employability</label>
            </span>

            <span v-else>
              <input
                type="checkbox"
                id="option4"
                v-on:click="checkboxesChecked"
                name="question7-1"
              />

              <label for="option4"> Employability</label>
            </span>

            <!-- Q7-5-->

            <span
              v-if="
                $store.state.views.questionSeven.checkedButtons[4] === idArry[4]
              "
            >
              <input
                type="checkbox"
                id="option5"
                v-on:click="checkboxesChecked"
                name="question7-1"
                checked
              />

              <label for="option5"> {{ answerOptions1[4] }}</label>
            </span>

            <span v-else>
              <input
                type="checkbox"
                id="option5"
                v-on:click="checkboxesChecked"
                name="question7-1"
              />

              <label for="option5"> {{ answerOptions1[4] }}</label>
            </span>
          </div>
        </div>
      </div>
      <div
        class="buttonDiv"
        v-if="
          showNextQuestion ||
          $store.state.views.questionSeven.nextPartofQuestion[0] === true
        "
      >
        <div class="paddingButtons">
          <h3 class="questionTitle">Please specify</h3>
          <div class="checkboxes">
            <!-- Q7-2-1-->

            <span
              v-if="
                $store.state.views.questionSeven.checkedButtons[5] === idArry[5]
              "
            >
              <input
                type="checkbox"
                id="option6"
                v-on:click="checkboxesChecked"
                name="question7-2"
                checked
              />

              <label for="option6"> Mental Health</label>
            </span>

            <span v-else>
              <input
                type="checkbox"
                id="option6"
                v-on:click="checkboxesChecked"
                name="question7-2"
              />

              <label for="option6"> Mental Health</label>
            </span>
            <!-- Q7-2-2-->

            <span
              v-if="
                $store.state.views.questionSeven.checkedButtons[6] === idArry[6]
              "
            >
              <input
                type="checkbox"
                id="option7"
                v-on:click="checkboxesChecked"
                name="question7-2"
                checked
              />

              <label for="option7"> {{ answerOptions2[1] }}</label>
            </span>

            <span v-else>
              <input
                type="checkbox"
                id="option7"
                v-on:click="checkboxesChecked"
                name="question7-2"
              />
              <label for="option7"> {{ answerOptions2[1] }}</label>
            </span>

            <!-- Q7-2-2-->

            <span
              v-if="
                $store.state.views.questionSeven.checkedButtons[7] === idArry[7]
              "
            >
              <input
                type="checkbox"
                id="option8"
                v-on:click="checkboxesChecked"
                name="question7-2"
                checked
              />

              <label for="option8"> Sexual Assault/Sexual Health</label>
            </span>

            <span v-else>
              <input
                type="checkbox"
                id="option8"
                v-on:click="checkboxesChecked"
                name="question7-2"
              />

              <label for="option8"> Sexual Assault/Sexual Health</label>
            </span>

            <!-- Q7-2-2-->

            <span
              v-if="
                $store.state.views.questionSeven.checkedButtons[8] === idArry[8]
              "
            >
              <input
                type="checkbox"
                id="option9"
                v-on:click="checkboxesChecked"
                name="question7-2"
                checked
              />

              <label for="option9"> Other</label>
            </span>

            <span v-else>
              <input
                type="checkbox"
                id="option9"
                v-on:click="checkboxesChecked"
                name="question7-2"
              />

              <label for="option9">Other</label>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="alignFooter">
      <div class="footerContainer">
        <HelpDialog />

        <button
          v-if="
            isActive ||
            $store.state.views.questionSeven.nextButtonActive == true
          "
          v-on:click="nextQuestion"
          class="nextButtonQuestions"
        >
          Next
          <span class="arrow">
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.63466 0.298041C8.45622 0.109282 8.20838 0 7.9308 0C7.38556 0 6.93945 0.447062 6.93945 0.99347C6.93945 1.27164 7.0485 1.52001 7.22694 1.69883L10.4885 4.96735H0.99135C0.446108 4.96735 0 5.41441 0 5.96082C0 6.50723 0.446108 6.95429 0.99135 6.95429H10.4984L7.23686 10.2228C7.05842 10.4016 6.94937 10.65 6.94937 10.9282C6.94937 11.4746 7.39547 11.9216 7.94072 11.9216C8.2183 11.9216 8.46613 11.8124 8.64458 11.6335L13.6013 6.66618C13.7798 6.48736 13.8888 6.23899 13.8888 5.96082C13.8888 5.68265 13.7699 5.44422 13.5914 5.26539L8.63466 0.298041Z"
                fill="#8380A8"
              />
            </svg>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store";
import BackButton from "./BackButton.vue";
import HelpDialog from "./HelpDialog.vue";

export default {
  name: "Q1",
  components: {
    BackButton,
    HelpDialog,
  },
  data() {
    return {
      answerOptions1: {
        0: "academics",
        1: "wellness",
        2: "finances",
        3: "employability",
        4: "campus-life",
      },

      idArry: {
        0: "option1",
        1: "option2",
        2: "option3",
        3: "option4",
        4: "option5",
        5: "option6",
        6: "option7",
        7: "option8",
        8: "option9",
      },
      answerOptions2: {
        0: "Mental Health Support",
        1: "Substance Use & Addictions",
        2: "Sexual Assault",
        3: "NULL",
      },
      isActive: false,
      showNextQuestion: false,
      arr: [],
      checkedAnswers: [],
    };
  },

  mounted: function () {
    this.scrollToTop();
  },

  methods: {
    nextQuestion() {
      var answerArray = [];
      var activeChecked = [];
      var i;
      var indexofChecked = 0;

      var checkboxes = document.getElementsByName("question7-1");
      for (i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          answerArray.push(this.answerOptions1[i]);
        }
      }

      for (i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          activeChecked[indexofChecked] = checkboxes[i].id;
          indexofChecked += 1;
        } else {
          activeChecked[indexofChecked] = "NULL";
          indexofChecked += 1;
        }
      }

      if (
        this.showNextQuestion ||
        store.state.views.questionSeven.nextPartofQuestion[0] === true
      ) {
        var checkboxes2 = document.getElementsByName("question7-2");
        for (i = 0; i < checkboxes2.length; i++) {
          if (checkboxes2[i].checked) {
            answerArray.push(this.answerOptions2[i]);
          }
        }

        for (i = 0; i < checkboxes2.length; i++) {
          if (checkboxes2[i].checked) {
            activeChecked[indexofChecked] = checkboxes2[i].id;
            indexofChecked += 1;
          } else {
            activeChecked[indexofChecked] = "NULL";
            indexofChecked += 1;
          }
        }
      }

      var objectForPages = {
        index: '["questionSeven"]',
        ans: answerArray,
      };

      var objectForChecked = {
        questionNum: '["questionSeven"]',
        checkedButtons: activeChecked,
      };
      store.commit("addAnswer", objectForPages);
      store.commit("setNextButtonActive", '["questionSeven"]');
      store.commit("setChecked", objectForChecked);
      store.commit("updatePage", '["questionEight"]');
      // store.commit("APPEND_SERVICE_TERM", objectForPages)
    },

    checkboxesChecked() {
      //this.scrollToBottom();

      var checkboxes = document.getElementsByName("question7-1");
      var checkboxes2 = document.getElementsByName("question7-2");
      var total = 0;
      var total2 = 0;
      var i;

      if (checkboxes[1].checked) {
        this.showNextQuestion = true;
        //this.scrollToBottom();
      } else {
        this.showNextQuestion = false;
        //set all of next question to false so the answer array does not add them
        for (i = 0; i < checkboxes2.length; i++) {
          checkboxes2[i].checked = false;
        }

        var objectForPageRemove = {
          index: '["questionSeven"]',
          questionNum: 0,
        };

        store.commit("removeNextQuestions", objectForPageRemove);
      }

      for (i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          total = total + 1;
        }
      }

      for (i = 0; i < checkboxes2.length; i++) {
        if (checkboxes2[i].checked) {
          total2 = total2 + 1;
        }
      }

      if (total === 0 || (checkboxes[1].checked && total2 === 0)) {
        this.isActive = false;
        store.commit("setNextButtonDeactive", '["questionSeven"]');
      } else {
        this.isActive = true;
      }

      /*
      console.log("hello");
      this.showNextQuestion = false;
      var objectForPageRemove = {
        index: '["questionSeven"]',
        questionNum: 0,
      };
      store.commit("removeNextQuestions", objectForPageRemove);
      store.commit("setNextButtonActive", '["questionSeven"]');
      this.isActive = true; */
    },

    scrollToBottom: function () {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    },
    scrollToTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
